import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import I18n from "i18next";

import MzButton from "@markaaz/ui/MzButton";
import Loading from "components/common/Loading/Loading";
import ConfirmationDialog from "components/common/ConfirmationDialog";
import FileUpload from "components/portfolio/FileUpload";
import AddPortfolio from "components/portfolio/AddPortfolio";
import PortfolioMain from "components/portfolio/PortfolioMain";
import { setAddPortfolioRow, selectAddPortfolioRow } from "store/slices/portfolioPage";

import {
  loadPorfolioData,
  deleteReport,
  addPortfolioName,
  removePortfolioName,
  uploadReport
} from "store/slices/portfolioPage";

import { selectPortfolioData } from "store/slices/portfolioPage";
import { selectPortfolios } from "store/slices/app";

const sx = {
  root: {
    maxWidth: "1200px"
  },

  btnNewFile: {
    textTransform: "capitalize"
  },
  header: {
    color: (theme) => theme.palette.darkBlue.c100,
    marginBottom: "40px"
  }
};

const PortfolioBoarding = () => {
  const addPortfolioRow = useSelector(selectAddPortfolioRow);
  const [confirmation, setConfirmation] = useState(false);
  const [selectedForDelete, setForDelete] = useState(false);
  const [fileUpload, setFileUpload] = useState(false);
  const [pageState, setPageState] = useState({ pageNo: 1 });

  const portfolioData = useSelector(selectPortfolioData);
  const portfolios = useSelector(selectPortfolios);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadPorfolioData(pageState.pageNo));
  }, [dispatch, pageState.pageNo]);

  function uploadFile() {
    setFileUpload(true);
    setConfirmation(false);
  }

  function handleDelete() {
    dispatch(deleteReport(selectedForDelete.id));
    setConfirmation(!confirmation);
  }

  function handlePortfolioSubmit(name, id) {
    const data = {
      portfolioBoardingFileId: addPortfolioRow.id,
      partnerPortfolioId: id,
      portfolioName: name
    };

    dispatch(addPortfolioName(data));
  }

  function handlePfDelete(row) {
    dispatch(removePortfolioName(row.id));
  }

  function handleDeleteFile(row) {
    setForDelete(row);
    setConfirmation(true);
  }

  function handleMenuItemClick(name, row) {
    if (name === "delete") {
      handleDeleteFile(row);
    } else if (name === "remove") {
      handlePfDelete(row);
    }
  }

  function handleAddPortfolio(row) {
    dispatch(setAddPortfolioRow(row));
  }

  function handleFileUpload(file) {
    const formData = new FormData();
    formData.append("boardingFile ", file);

    dispatch(uploadReport(formData));

    setFileUpload(!fileUpload);
  }

  function handleFileUploadClose() {
    setFileUpload(!fileUpload);
  }

  function onPageChange(newPage) {
    setPageState({ pageNo: newPage + 1 });
  }

  return (
    <>
      {!portfolioData ? (
        <Loading />
      ) : (
        <Box sx={sx.root}>
          <Typography variant="h4" sx={sx.header}>
            {I18n.t("portfolioBoarding.portfolioBoarding")}
          </Typography>

          <PortfolioMain
            rows={portfolioData}
            onMenuItemClick={handleMenuItemClick}
            onAddPortfolio={handleAddPortfolio}
            onPageChange={onPageChange}
          />

          <Box display="flex" marginY="10px" zIndex={4}>
            <MzButton onClick={uploadFile} variant="contained" size="large" sx={sx.btnNewFile}>
              {I18n.t("common.uploadNewFile")}
            </MzButton>
          </Box>

          <FileUpload isOpen={fileUpload} onUpload={handleFileUpload} onClose={handleFileUploadClose} />

          <ConfirmationDialog
            description={`${I18n.t("portfolioBoarding.deleteConfirmation")}`}
            onConfirm={handleDelete}
            open={confirmation}
            handleClose={() => setConfirmation(!confirmation)}
          />

          <AddPortfolio
            open={addPortfolioRow != null}
            portfolios={portfolios}
            handleClose={() => {
              dispatch(setAddPortfolioRow(null));
            }}
            handleSubmit={handlePortfolioSubmit}
          />
        </Box>
      )}
    </>
  );
};

export default PortfolioBoarding;
